(function () {
  'use strict';
  var routes = window.t23Routes || { root: '/', cartAdd: '/cart/add.js', cartChange: '/cart/change.js' };
  var root = routes.root.charAt(routes.root.length - 1) === '/' ? routes.root : routes.root + '/';
  var lastFocus = null;

  /* ---------- Menu ---------- */
  function initMenu() {
    var menu = document.querySelector('[data-t23-menu]');
    var openBtn = document.querySelector('[data-t23-menu-open]');
    if (!menu || !openBtn) return;
    openBtn.addEventListener('click', function () {
      lastFocus = openBtn;
      menu.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('t23-lock');
      var c = menu.querySelector('[data-t23-menu-close]');
      if (c) c.focus();
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('[data-t23-menu-close]')) closeMenu();
    });
    function closeMenu() {
      menu.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('t23-lock');
      openBtn.focus();
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) closeMenu();
    });
  }

  /* ---------- Cart drawer ---------- */
  function drawerWrap() { return document.querySelector('[data-t23-drawer]'); }

  function openDrawer(refresh) {
    var w = drawerWrap();
    if (!w) return;
    if (refresh) w.classList.add('is-refresh'); else w.classList.remove('is-refresh');
    if (w.hidden) lastFocus = document.activeElement;
    w.hidden = false;
    document.body.classList.add('t23-lock');
    var x = w.querySelector('.t23-x');
    if (x && !refresh) x.focus();
  }

  function closeDrawer() {
    var w = drawerWrap();
    if (!w || w.hidden) return;
    w.hidden = true;
    document.body.classList.remove('t23-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderDrawer(html, keepOpen) {
    var w = drawerWrap();
    if (!w || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-t23-drawer]');
    if (!fresh) return;
    w.innerHTML = fresh.innerHTML;
    if (keepOpen) openDrawer(true);
    var count = w.querySelectorAll('.t23-line').length;
    document.querySelectorAll('[data-t23-cart-dot]').forEach(function (d) { d.hidden = count === 0; });
  }

  function fetchDrawer() {
    return fetch(root + '?sections=t23-cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { return data['t23-cart-drawer']; });
  }

  function changeLine(key, qty) {
    var w = drawerWrap();
    var d = w && w.querySelector('.t23-drawer');
    if (d) d.classList.add('is-busy');
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 't23-cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['t23-cart-drawer']) renderDrawer(data.sections['t23-cart-drawer'], true);
        else return fetchDrawer().then(function (h) { renderDrawer(h, true); });
      })
      .catch(function () { if (d) d.classList.remove('is-busy'); });
  }

  function initDrawer() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-t23-cart-open]');
      if (open && drawerWrap()) {
        e.preventDefault();
        openDrawer(false);
        return;
      }
      if (e.target.closest('[data-t23-cart-close]')) { closeDrawer(); return; }
      var q = e.target.closest('[data-t23-qty]');
      if (q) {
        var line = q.closest('[data-key]');
        if (line) changeLine(line.getAttribute('data-key'), parseInt(q.getAttribute('data-t23-qty'), 10) || 0);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ---------- Product ---------- */
  function initProduct() {
    var wrap = document.querySelector('[data-t23-product]');
    if (!wrap) return;

    // Gallery
    var track = wrap.querySelector('[data-t23-track]');
    var gotos = wrap.querySelectorAll('[data-t23-goto]');
    function setActive(i) {
      wrap.querySelectorAll('.t23-gal__thumb').forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
      wrap.querySelectorAll('.t23-gal__dot').forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
    }
    gotos.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.getAttribute('data-t23-goto'), 10) || 0;
        if (track) track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        setActive(i);
      });
    });
    if (track) {
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { setActive(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))); }, 60);
      });
    }

    // Variant picker
    var form = wrap.querySelector('[data-t23-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-t23-variant]');
    var addBtn = form.querySelector('[data-t23-add]');
    var err = form.querySelector('[data-t23-error]');
    var sizeLabel = form.querySelector('[data-t23-size-label]');
    var leftNote = form.querySelector('[data-t23-left]');
    var priceBox = wrap.querySelector('[data-t23-price]');

    function chooseVariant(id, label, left, price, compare) {
      idInput.value = id;
      if (sizeLabel && label) sizeLabel.textContent = label;
      if (leftNote) {
        if (left) {
          leftNote.hidden = false;
          leftNote.innerHTML = 'Only <span>' + left + '</span> left in ' + label;
        } else {
          leftNote.hidden = true;
        }
      }
      if (priceBox && price) {
        priceBox.innerHTML = '<span>' + price + '</span>' + (compare ? '<s>' + compare + '</s>' : '');
      }
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.querySelector('span').textContent = 'Add to cart';
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    form.querySelectorAll('input[name="t23-size"]').forEach(function (r) {
      r.addEventListener('change', function () {
        chooseVariant(r.value, r.getAttribute('data-label'), r.getAttribute('data-left'), r.getAttribute('data-price'), r.getAttribute('data-compare'));
      });
    });
    var sel = form.querySelector('[data-t23-select]');
    if (sel) sel.addEventListener('change', function () { chooseVariant(sel.value); });

    form.addEventListener('submit', function (e) {
      if (!drawerWrap()) return;
      e.preventDefault();
      if (err) err.hidden = true;
      addBtn.disabled = true;
      var label = addBtn.querySelector('span');
      label.textContent = 'Adding…';
      fetch(routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }], sections: 't23-cart-drawer' })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message) || 'Could not add to cart');
          label.textContent = 'Added to cart';
          var html = res.data.sections && res.data.sections['t23-cart-drawer'];
          var p = html ? Promise.resolve(html) : fetchDrawer();
          return p.then(function (h) {
            renderDrawer(h, false);
            openDrawer(false);
          });
        })
        .catch(function (e2) {
          label.textContent = 'Add to cart';
          if (err) { err.textContent = e2.message; err.hidden = false; }
        })
        .then(function () {
          addBtn.disabled = false;
          setTimeout(function () { label.textContent = 'Add to cart'; }, 2000);
        });
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    var s = document.querySelector('[data-t23-sort]');
    if (!s) return;
    s.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }


  /* ---------- Email popup ---------- */
  function initPop() {
    var p = document.querySelector('[data-t23-pop]');
    if (!p) return;
    var KEY = 't23-pop-until';
    var days = parseInt(p.getAttribute('data-days'), 10) || 14;
    var delay = (parseInt(p.getAttribute('data-delay'), 10) || 6) * 1000;
    var prev = null;
    function store(d) { try { localStorage.setItem(KEY, String(Date.now() + d * 864e5)); } catch (e) {} }
    function seen() { try { return Number(localStorage.getItem(KEY) || 0) > Date.now(); } catch (e) { return false; } }
    function open() {
      prev = document.activeElement;
      p.hidden = false;
      document.body.classList.add('t23-lock');
      var f = p.querySelector('input[type="email"]') || p.querySelector('.t23-pop__x');
      if (f) f.focus({ preventScroll: true });
    }
    function close() {
      p.hidden = true;
      var d = document.querySelector('[data-t23-drawer]');
      if (!d || d.hidden) document.body.classList.remove('t23-lock');
      store(days);
      if (prev && prev.focus) prev.focus();
    }
    p.addEventListener('click', function (e) { if (e.target.closest('[data-t23-pop-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !p.hidden) close(); });
    var form = p.querySelector('form');
    if (form) form.addEventListener('submit', function () { store(365); });
    if (window.location.hash === '#T23PopForm') { open(); store(365); return; }
    if (seen()) return;
    setTimeout(function () {
      var busy = document.querySelector('[data-t23-drawer]:not([hidden])') || document.querySelector('[data-t23-menu]:not([hidden])');
      if (!busy) open();
    }, delay);
  }

  function init() { initMenu(); initDrawer(); initProduct(); initSort(); initPop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
